<template>
    <div id="topMostElement" class="providerSection">
        <div :style="`z-index: 1; position: absolute; right: 7%; top: ${screen_width >= 1265 ? '13px' : '80px;'}; width: auto`">
            <v-alert
                v-model="notif.show"
                transition="scroll-x-reverse-transition"
                :type="notif.type"
                :color="notif.color"
                dismissible
            >
                {{ notif.msg }}
            </v-alert>
        </div>
        <h1>
            <v-icon
                v-if="screen_width > 520"
                x-large
                elevation="10"
                class="white--text"
                style="height: 50px; width: 50px; background-color: #009688; border-radius: 25px; margin-right: 2%;"
            >
                {{ mdiCancel }}
            </v-icon>
            Cancel Portal Approval
            <v-btn
                v-if="isApprovalValid && screen_width > 810"
                style="position: absolute; right: 6.5%; background-color: #009688; color: white;"
                class="ma-2"
                dark
                @click="handleGoBackBtn"
            >
                <v-icon
                    dark
                    left
                >
                    {{ mdiChevronLeft }}
                </v-icon>GO BACK
            </v-btn>
        </h1>
        <v-tooltip top open-delay="300">
            <template #activator="{ on, attrs }">
                <v-btn
                    v-show="!isApprovalValid && !showCancelled"
                    v-bind="attrs"
                    style="margin: 15px 0; text-transform: none;"
                    elevation="3"
                    v-on="on"
                    @click="showCancelled = true"
                >
                    🕘 View Cancelled Approvals
                </v-btn>
            </template>
            <span>View previously cancelled approvals</span>
        </v-tooltip>
        <div v-if="!showCancelled">
            <VerifyApproval
                v-if="!isApprovalValid"
                @isApprovalValid="handleApprovalResult"
            />
            <CancelForm
                v-else-if="approvalData"
                :approval-data="approvalData"
                :notif="notif"
                :is-cancel-on-process="isCancelOnProcess"
                :remarks="remarks"
                :is-cancel-success="isCancelSuccess"
                @isApprovalHasResult="handleApprovalHasResult"
                @confirmCancel="handleConfirmCancel"
            />
            <CancelResult
                :show="showCancelResult"
                :approval-result="approvalResult"
                :approval-data="approvalData"
                :is-approval-has-result="isApprovalHasResult"
                @closeDialog="handleCloseDialog"
                @cancelApproval="handleCancelApproval"
            />
        </div>
        <CancelledApprovals 
            v-show="showCancelled"
            :show-cancelled="showCancelled"
            @closeListOfCancelledApprovals="showCancelled=false"
        />
    </div>
</template>

<script>
import VerifyApproval from './VerifyApproval.vue'
import CancelForm from './CancelForm.vue'
import CancelResult from './CancelResult.vue'
import CancelledApprovals from './CancelledApprovals.vue'
import {
    mdiCancel,
    mdiChevronLeft
} from '@mdi/js'

export default {
    components: { VerifyApproval, CancelForm, CancelResult, CancelledApprovals },
    data: ()=>({
        mdiCancel,
        mdiChevronLeft,
        showCancelled: false,
        isCancelSuccess: { value: false },
        remarks: null,
        notif: {
            show: false,
            type: 'success',
            msg: 'Done',
            color: 'success'
        },
        showCancelResult: false,
        approvalResult: null,
        approvalData: null,
        membInfo: null,
        isApprovalHasResult: false,
        isApprovalValid: false,
        isCancelOnProcess: false,
        valid: true,
        goToOptions: {
            duration: 500,
            offset: 0,
            easing: 'easeInOutCubic'
        },
        screen_width: document.documentElement.clientWidth + 9
    }),
    watch: {
        isCancelSuccess: {
            handler(newVal) {
                console.log('isCancelSuccess newVal: ', newVal)
            },
            deep: true,
            immediate: true
        },
        notif: {
            handler(newVal) {
                if (newVal.show) {
                    if (newVal.timeout !== 0) {
                        setTimeout(() => {
                            this.notif.show = false
                        }, newVal.timeout)
                    }
                }
            },
            deep: true
        }
    },
    mounted(){
        window.addEventListener('resize', this.onResize)
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        handleCloseDialog() {
            this.isCancelOnProcess = false
            this.showCancelResult = false
            this.$store.commit('FETCH_PORTAL_APPROVAL', null)
            console.log('handleCloseDialog: ')
            this.approvalResult = null
            if (this.isCancelSuccess.value) {
                this.isCancelSuccess.value = false
                this.isApprovalValid = false
                this.showCancelled = true
            }
        },
        handleConfirmCancel() {
            this.showCancelResult = true
        },
        handleCancelApproval(remarks) {
            this.remarks = remarks
            this.isCancelOnProcess = true
        },
        handleGoBackBtn() {
            this.isApprovalValid = false
        },
        handleApprovalHasResult(newVal) {
            console.log('handleApprovalHasResult newVal: ', newVal)
            if (newVal && newVal.data && newVal.data[0]) {
                this.approvalData = { membInfo: newVal.data[0], diagnostics: newVal.data }
            }
            this.approvalResult = structuredClone(newVal)
        },
        handleApprovalResult(newVal) {
            this.approvalData = { membInfo: newVal.data[0], diagnostics: newVal.data }
            this.isApprovalValid = true
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 9
        }
    }
}
</script>

<style scoped>
h1 {
    font-size: 25px;
    padding: 10px;
    border-bottom: 1px solid #bbb;
}
</style>
